/**
 * Generated by orval v6.6.4 🍺
 * Do not edit manually.
 * QRS Sample Management Backend
 * OpenAPI spec version: v3
 */
import {
  useQuery,
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "react-query";
import type { DownloadReportParams } from "../backend.schemas";
import { apiRequest } from ".././client";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

export const downloadReport = (
  params?: DownloadReportParams,
  options?: SecondParameter<typeof apiRequest>
) => {
  return apiRequest<void>({ url: `/Report`, method: "get", params }, options);
};

export const getDownloadReportQueryKey = (params?: DownloadReportParams) => [
  `/Report`,
  ...(params ? [params] : []),
];

export const useDownloadReport = <
  TData = AsyncReturnType<typeof downloadReport>,
  TError = unknown
>(
  params?: DownloadReportParams,
  options?: {
    query?: UseQueryOptions<
      AsyncReturnType<typeof downloadReport>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiRequest>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};

  const queryKey = queryOptions?.queryKey ?? getDownloadReportQueryKey(params);

  const queryFn: QueryFunction<AsyncReturnType<typeof downloadReport>> = () =>
    downloadReport(params, requestOptions);

  const query = useQuery<AsyncReturnType<typeof downloadReport>, TError, TData>(
    queryKey,
    queryFn,
    queryOptions
  );

  return {
    queryKey,
    ...query,
  };
};
